module.exports = __webpack_public_path__ + "img/27armlge.d7d1ae77.png";